import { canInsertInlineIn, INLINE_EMOJI } from '@gitbook/doc-core';
import type { InlineProps, Plugin } from '@gitbook/slate-react';

import { createTypePlugin } from '../type-plugin';
import { EmojiPickerMark } from './EmojiPickerMark';
import { InlineEmoji } from './InlineEmoji';

const EMOJI_CONTEXT_TYPE = 'emojiContext';

const typePlugin = createTypePlugin({
    symbols: [':'],
    markType: EMOJI_CONTEXT_TYPE,
    getData: ({ value, textValue }) => {
        const { document, startBlock } = value;
        if (!startBlock) {
            return null;
        }
        if (!canInsertInlineIn({ document, block: startBlock }, INLINE_EMOJI)) {
            return null;
        }
        return { value: textValue };
    },
    renderMark: (props) => {
        return <EmojiPickerMark {...props} />;
    },
});
/**
 * Slate plugin to detect user typing ":".
 */
export const emojiPlugin: Plugin = {
    ...typePlugin,
    renderNode: (props: InlineProps) => {
        const { node } = props;
        if (node.type === INLINE_EMOJI) {
            return <InlineEmoji {...props} />;
        }
        return null;
    },
};
